var exports = {
  "K": "SavedMessagesPage.module__icon___UU5lT0",
  "r": "SavedMessagesPage.module__missingList___UU5lT0",
};

module.exports = exports;
